import { DocumentService } from "./lib/services/document_service";
export { localStorageFavoritesKey } from "./lib/services/document_service";
export { CdocFormat } from "./lib/const/cdocFormat";
export { constructDocumentName } from "./lib/utils/filename";
export { constructDocumentPayload, cleanFormRecord } from "./lib/utils/payload";
export type {
    IDocumentAttachProps,
    IDocumentPayloadProps,
    IVendorBank,
    IVendor,
    IMassUpload,
    IProcessingStatus,
    IRecordHistoryItem
} from "./lib/types/document_service_types"
export type { IHrPerson, IHrAccount } from "./lib/types/hr_person_types";

export const documentService = new DocumentService();
